import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";

const HistoryToolbarGroup = () => {
  const { editor } = useEditorContext();

  return (
    <>
      <ToolbarItem
        id="history-undo-toolbar-item"
        tooltip="Visszavonás"
        disabled={!editor.can().undo()}
        onToggle={() => editor.chain().focus().undo().run()}
        hotkey="Ctrl + Z"
        icon={
          <i
            className={`fa fa-turn-up`}
            aria-hidden="true"
            style={{ transform: "rotate(-90deg)", marginBottom: 4 }}
          />
        }
      />
      <ToolbarItem
        id="history-redo-toolbar-item"
        tooltip="Ismét"
        disabled={!editor.can().redo()}
        onToggle={() => editor.chain().focus().redo().run()}
        hotkey="Ctrl + Y"
        icon={
          <i
            className={`fa fa-turn-down`}
            aria-hidden="true"
            style={{ transform: "rotate(-90deg)", marginBottom: 4 }}
          />
        }
      />
      <ToolbarItem
        id="clear-marks-toolbar-item"
        tooltip="Formázások törlése"
        onToggle={() => editor.chain().focus().unsetAllMarks().run()}
        icon={<i className={`fa fa-text-slash`} aria-hidden="true" />}
      />
    </>
  );
};

export default HistoryToolbarGroup;
